import React from 'react';
import { 
    Create, 
    SimpleForm, 
    TextInput,
    NumberInput,
    required 
} from 'react-admin';
import { FormToolbar } from "../../common/FormToolbar";

export const ClassCreate = props => {
    return (
        <React.Fragment>
            <Create label="Create Class" {...props}>
                <SimpleForm toolbar={<FormToolbar {...props} />} className="main-form">
                    <TextInput 
                        source="class_name" 
                        label='Class Name' 
                        fullWidth={true}
                        className="first_inline_input"
                        validate={[required()]} 
                        helperText="E.g., Class 9, Class 10, etc."
                    />
                    <NumberInput 
                        source="numeric_equivalent" 
                        label='Class Number' 
                        fullWidth={true}
                        className="last_inline_input"
                        validate={[required()]}
                        min={1}
                        max={12}
                        helperText="Numeric value (9, 10, 11, 12)"
                    />
                </SimpleForm>
            </Create>
        </React.Fragment>
    );
}
